module.exports = __webpack_public_path__ + "static/media/book-now-image-2c.dd207df8.png";